import { AiConnection, AiSourcesState } from './types';

const BASE_URL = 'https://keycloak.okton.com.br/platform-api';

export class AiSourcesError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'AiSourcesError';
    this.status = status;
  }
}

async function request<T>(
  systemId: string,
  accessToken: string,
  resource: 'sources' | 'connections',
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(
    BASE_URL + '/v1/admin/applications/' + encodeURIComponent(systemId) + '/ai-' + resource,
    {
      ...options,
      credentials: 'include',
      headers: { Authorization: 'Bearer ' + accessToken, 'Content-Type': 'application/json' },
    },
  );
  const payload = await response.json();
  if (!response.ok) {
    throw new AiSourcesError(payload.message || 'Não foi possível acessar as fontes.', response.status);
  }
  return payload.data as T;
}

export function loadAiSources(systemId: string, token: string, signal: AbortSignal): Promise<AiSourcesState> {
  return request(systemId, token, 'sources', { signal });
}

export function loadAiConnections(systemId: string, token: string, signal: AbortSignal): Promise<AiConnection[]> {
  return request(systemId, token, 'connections', { signal });
}

export function saveAiSources(
  systemId: string,
  token: string,
  state: Pick<AiSourcesState, 'revision' | 'items'>,
  signal: AbortSignal,
): Promise<AiSourcesState> {
  return request(systemId, token, 'sources', { method: 'PUT', body: JSON.stringify(state), signal });
}
